/**
 * Состав пака «blue-gradient» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 1 воронок: паки/slimkit.health.json и признаки.json (пак снят со Slimkit)
  palettes: [
    // 1 из 1 воронок: palette → ближайшая тема по цветам
    { themeId: 'blue-gradient-light', weight: 1.0 },
  ],
  fonts: [
    // 1 из 1 воронок: fontId
    { fontId: 'inter', weight: 1.0 },
  ],
  screenKinds: [
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.333
    { kind: 'Q1', share: 0.36 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.123
    { kind: 'N5', share: 0.13 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.105; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.11 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.088
    { kind: 'N8', share: 0.09 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.088; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.09 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.088
    { kind: 'Q12', share: 0.09 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.070
    { kind: 'I1', share: 0.08 },
    // средняя доля экранов по 1 воронкам (признаки.json kinds) 0.035
    { kind: 'N6', share: 0.04 },
  ],
  blocks: [
    // в 1 из 1 воронок (признаки.json blocks), подъём 2.22; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 4 из 5, optionIconPosition 4 из 5
    {
      type: 'multiple_choice',
      weight: 1.0,
      settings: { optionIndicator: 'none', optionIconPosition: 'left' },
    },
    // в 1 из 1 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 24 из 26, optionIndicator 26 из 26, optionIconPosition 16 из 26
    {
      type: 'single_choice',
      weight: 1.0,
      settings: {
        autoAdvance: true,
        optionIndicator: 'none',
        optionIconPosition: 'left',
      },
    },
  ],
  niches: [
    // 1 из 1 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 1.0 },
  ],
};
